<template>
  <div class="pt-3 sticky">
    <b-row>
      <b-col>
        <h4>{{ header }}</h4>
      </b-col>
      <b-col>
        <b-row 
          align-h="end" 
          no-gutters>
          <b-button 
            variant="info" 
            @click="$emit('onclick')">Save</b-button>
        </b-row>
      </b-col>
    </b-row>
    <hr>
  </div>
</template>

<script>
export default {
  props: {
    header: String
  }
}
</script>

<style>
  .sticky {
    z-index: 10;
    background: white;
    position: sticky !important;
    -webkit-position: sticky !important;
    top: 0;
  }
</style>
